module.exports = __webpack_public_path__ + "img/ring_g_skip_1_1@2x.c7942f28.png";